import * as THREE from 'three';
import OrbitControls from './OrbitControls'
import {RGBELoader} from './RGBELoader'

export default (canvas, onUpdate) => {
    let sceneIsReady = false
    const clock = new THREE.Clock();
    const origin = new THREE.Vector3(0,0,0);

    const screenDimensions = {
      width: canvas.width,
      height: canvas.height
    }

    let scene
    let renderer
    let camera
    let controls
    let envMap

    function setCamera (cam) {
      cam.aspect = screenDimensions.width / screenDimensions.height
      cam.updateProjectionMatrix()
      camera = cam
    }
    function getCamera () { return camera }

    function setScene (sc) {
      scene = sc
    }
    function getScene () { return scene }

    function buildRender({ width, height }) {
        const renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, precision: 'highp', alpha: true});
        const DPR = window.devicePixelRatio ? window.devicePixelRatio : 1;
        renderer.setPixelRatio(DPR);
        renderer.setSize(width, height);
        renderer.setClearColor(new THREE.Color(0,0,0))
        renderer.setClearAlpha(1)
        renderer.autoClearColor = false;
        renderer.gammaFactor = 2.2
        renderer.outputEncoding = THREE.sRGBEncoding

        let pmremGenerator = new THREE.PMREMGenerator(renderer)
        pmremGenerator.compileEquirectangularShader()

        new RGBELoader().setDataType(THREE.UnsignedByteType).load("./export_final/textures/venice_sunset_1k.hdr", (texture) => {
          envMap = pmremGenerator.fromEquirectangular(texture).texture
          pmremGenerator.dispose()
        })

        return renderer;
    }

    function buildCamera(scene, { width, height }) {
        /*let camera = scene.children[scene.children.length - 1]
        camera = camera.children[camera.children.length - 1]
        console.log(camera)*/

        const aspectRatio = width / height;
        console.log(width, height)
        const fieldOfView = 29;
        const nearPlane = 0.1;
        const farPlane = 1000;
        const camera = new THREE.PerspectiveCamera(fieldOfView, aspectRatio, nearPlane, farPlane);

        camera.position.x = 0
        camera.position.z = -21.459
        camera.position.y = 12.132
        camera.up.set(0, 1, 0)
        camera.lookAt(0,0,0)

        return camera;
    }

    let lastElapsedTime = 0
    function update() {
      if (!sceneIsReady) return
        /*const elapsedTime = clock.getElapsedTime();
        const fps = Math.floor(1 / (elapsedTime-lastElapsedTime))
        if (fps < 50 || fps > 70) console.log(Math.floor(1 / (elapsedTime-lastElapsedTime)).toString() + ' FPS')
        lastElapsedTime = elapsedTime*/

        if (envMap) scene.environment = envMap
        renderer.render(scene, camera);

        if (onUpdate) onUpdate()
    }

    function onWindowResize(width, height) {
        if (!camera || !scene) return

        if (screenDimensions.width === width && screenDimensions.height === height) return

        screenDimensions.width = width;
        screenDimensions.height = height;

        camera.aspect = width / height;
        //camera.fov = 35.48934 / camera.aspect
        camera.updateProjectionMatrix();

        renderer.setSize(width, height);
    }

    renderer = buildRender(screenDimensions)
    sceneIsReady = true

    return {
        update,
        onWindowResize,
        setCamera,
        setScene,
        getScene,
        getCamera
    }
}
